import React, { useMemo } from 'react'
import { ODVSpace } from '@mdpp/od-react-belt'
import { useHistory } from 'react-router-dom'
import { EvixButton, EvixButtonTheme } from '../../common/EvixButton'

//asset
import {
  Wrap,
  SignUpWrap,
  Header,
  PageTitleWrap,
  ProcessWrap,
  PharmacyLogo,
  PageTitle,
  Step,
  StepCircle,
  StepText,
  Container,
  Title,
  TermWrap,
  BtnWrap,
} from '../../common/style/SignUpStyle'
import { InputCheckboxSupportWrapper } from '../../common/style/CommonStyle'
import IconPharmacy from '../../assets/common/icon-pharmacy.png'
import styled from 'styled-components'

export const PharmacySignUpPage: React.FC = () => {
  const [pharmaRememberCheck1, setPharmaRememberCheck1] = React.useState(false)
  const [pharmaRememberCheck2, setPharmaRememberCheck2] = React.useState(false)

  // 다음 버튼 클릭 시, 이동
  const history = useHistory()
  const handleNextPharmacy = () => {
    let path = `/pharmacy/signupInfo`
    history.push(path)
  }

  // 메디팡팡 이용약관에 동의합니다. (필수)
  const pharmaHandleCheck1 = () => {
    setPharmaRememberCheck1(!pharmaRememberCheck1)
  }

  // 개인정보 수집 및 이용 동의 (필수)
  const pharmaHandleCheck2 = () => {
    setPharmaRememberCheck2(!pharmaRememberCheck2)
  }

  const handlePharmaAgree = (src: string) => {
    return <PharmacyFrame src={src} />
  }

  const PharmacyFrame = styled.iframe`
    width: 100%;
    height: 100%;
  `

  const agreePharmaTerms = React.useMemo(
    () =>
      handlePharmaAgree(
        '/notice/terms/index.html'
      ),
    []
  )

  const agreePharmaInfo = React.useMemo(
    () =>
      handlePharmaAgree(
        'https://medi-pangpang-cs.s3.ap-northeast-2.amazonaws.com/notice/%EA%B0%9C%EC%9D%B8%EC%A0%95%EB%B3%B4%EC%88%98%EC%A7%91%EB%B0%8F%EC%9D%B4%EC%9A%A9%EB%8F%99%EC%9D%98/common/index.html'
      ),
    []
  )

  return (
    <Wrap>
      <SignUpWrap>
        <Header>
          <PageTitleWrap>
            <img src={IconPharmacy} style={PharmacyLogo} alt="약사 아이콘" />
            <PageTitle>회원가입</PageTitle>
          </PageTitleWrap>
          <ProcessWrap>
            <Step className="active">
              <StepCircle>
                <span>1</span>
              </StepCircle>
              <StepText>약관 동의</StepText>
            </Step>
            <Step>
              <StepCircle>
                <span>2</span>
              </StepCircle>
              <StepText>가입정보 입력</StepText>
            </Step>
            <Step>
              <StepCircle>
                <span>3</span>
              </StepCircle>
              <StepText>이메일 인증</StepText>
            </Step>
            <Step>
              <StepCircle>
                <span>4</span>
              </StepCircle>
              <StepText>가입 승인 요청</StepText>
            </Step>
          </ProcessWrap>
        </Header>

        <Container>
          <Title>이용약관</Title>
          <InputCheckboxSupportWrapper className="termText">
            <input type="checkbox" id="cb1" onChange={pharmaHandleCheck1} checked={pharmaRememberCheck1} />
            <label htmlFor="cb1">메디팡팡 이용약관에 동의합니다. (필수) </label>
          </InputCheckboxSupportWrapper>
          <ODVSpace h={20} />
          <TermWrap>{agreePharmaTerms}</TermWrap>
          <ODVSpace h={54} />

          <Title>개인정보 수집 및 이용 동의</Title>
          <InputCheckboxSupportWrapper className="termText">
            <input type="checkbox" id="cb2" onChange={pharmaHandleCheck2} checked={pharmaRememberCheck2} />
            <label htmlFor="cb2">개인정보 수집 및 이용 동의 (필수)</label>
          </InputCheckboxSupportWrapper>
          <ODVSpace h={20} />
          <TermWrap>{agreePharmaInfo}</TermWrap>
          <ODVSpace h={60} />

          <BtnWrap>
            <EvixButton
              theme={EvixButtonTheme.H48Black}
              onClick={handleNextPharmacy}
              disabled={!(pharmaRememberCheck1 && pharmaRememberCheck2)}
            >
              다음
            </EvixButton>
          </BtnWrap>
        </Container>
      </SignUpWrap>
    </Wrap>
  )
}
